import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdminAIModelDetailPage, type AdminAIModelDetailPageProps } from '../ui/admin/AdminAIModelDetailPage';

export function AdminAIModelDetailPageContainer(props: AdminAIModelDetailPageProps) {
  return <AdminAIModelDetailPage {...props} />;
}

export function mountAdminAIModelDetailPage(
  container: HTMLElement,
  props: AdminAIModelDetailPageProps
) {
  const root = createRoot(container);
  root.render(<AdminAIModelDetailPageContainer {...props} />);
  return root;
}

export default AdminAIModelDetailPageContainer;
